import React from 'react'
import ScmList from '../../components/scmcomponents/ScmList';

function ScmDetails(renderPageContent) {
    return (
        <>
            <ScmList renderPageContent={renderPageContent} />


        </>
    )
}

export default ScmDetails
